export const REWARD_TYPES = {
  BONUS_PRODUCTS: 'BONUS_PRODUCTS',
  PRODUCT: 'PRODUCT',
  PEP_VOUCHER_PRODUCT: 'PEP_VOUCHER_PRODUCT',
  PEP_VOUCHER_DISCOUNT: 'PEP_VOUCHER_DISCOUNT',
  VISA_CARD: 'VISA_CARD',
  PHYSICAL: 'PHYSICAL',
  CASH: 'CASH',
  DISCOUNT: 'DISCOUNT',
  DIGITAL: 'DIGITAL',
  DIGITAL_PRE_ORDER: 'DIGITAL_PRE_ORDER',
  LOYALTY: 'LOYALTY',
}

export const INVENTORY_MANAGED_REWARD_TYPES = [
  REWARD_TYPES.CASH,
  REWARD_TYPES.PRODUCT,
  REWARD_TYPES.PHYSICAL,
  REWARD_TYPES.DIGITAL,
  REWARD_TYPES.DIGITAL_PRE_ORDER,
  REWARD_TYPES.LOYALTY,
  REWARD_TYPES.PEP_VOUCHER_DISCOUNT,
]

export const isInventoryManagedRewardType = (rewardType, rewardCardType) => {
  if (!rewardType) return false

  if (INVENTORY_MANAGED_REWARD_TYPES.includes(rewardType)) {
    return true
  }

  if (rewardType === REWARD_TYPES.VISA_CARD) {
    return rewardCardType !== REWARD_CARD_TYPES.Both
  }

  return false
}

export const REWARD_CARD_TYPES = {
  Physical: 'Physical',
  Digital: 'Digital',
  Both: 'Both',
}

export const REWARD_STATUS = {
  DRAFT: 'Draft',
  EXPIRED: 'Expired',
  REVOKED: 'Revoked',
}
